<template>
  <div id="pageRoot">
    <img id="bg" class="pageElement" src="/pages/img/sordocas/svgCas34bg.svg" />

    <span class="normalTheme pageInstruction" style="left: 67px; top: 150px">
      <p>Presta atención a las expresiones destacadas.</p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 67px; top: 200px">
      <p>Marca la opción correcta.</p>
    </span>

    <p class="textBase appearAnimationB" id="text01">
      EN EUROPA SE CONSTRUYERON
    </p>
    <p class="textBase hover-animation-c appearAnimationA" id="tag01">
      GRANDES RESIDENCIAS
    </p>
    <p class="textBase appearAnimationB" id="text02">ES LO MISMO QUE DECIR</p>

    <label class="toggleButtonContainer pageElement" id="toggle01"
      >EN EUROPA SE CONSTRUYERON VIVIENDAS MUY GRANDES.
      <input
        type="radio"
        name="grillos"
        ref="1-1"
        v-on:change="saveOption('radios', 1, 1)"
        :onload="loadOption('radios', 1, 1)"
      />
      <span class="toggleButton"></span>
    </label>
    <label class="toggleButtonContainer pageElement" id="toggle02"
      >EN EUROPA SE CONSTRUYERON INMENSAS ESCUELAS.
      <input
        type="radio"
        name="grillos"
        ref="1-2"
        v-on:change="saveOption('radios', 1, 2)"
        :onload="loadOption('radios', 1, 2)"
      />
      <span class="toggleButton"></span>
    </label>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 64px;
  top: 67px;
}
#text01 {
  position: absolute;
  width: 730px;
  height: 50px;
  left: 70px;
  top: 334px;
  font-style: italic;
  font-weight: normal;
  font-size: 29px;
  line-height: 45px;
  color: #000000;
}
#tag01 {
  position: absolute;
  width: 350px;
  height: 50px;
  left: 513px;
  top: 333px;
  text-align: center;
  background-color: #00a5a5;
  font-style: italic;
  font-weight: normal;
  font-size: 29px;
  line-height: 45px;
  color: #ffffff;
}
#text02 {
  position: absolute;
  left: 69px;
  top: 415px;
  font-size: 30px;
  line-height: 41px;
  color: #00a5a5;
}

label {
  font-style: italic;
  text-transform: uppercase;
  font-size: 29px;
}
#toggle01 {
  position: absolute;
  left: 67px;
  top: 495px;
}
#toggle02 {
  position: absolute;
  left: 67px;
  top: 570px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "cas/Video 134.mp4",
        "cas/Video 135-136-137.mp4",
        "cas/Video 138.mp4",
      ],
    };
  },
  methods: {
    dbId(name, group) {
      return `${this.$parent.pageID()}-${name}-${group}`;
    },
    async loadOption(name, group, option) {
      var id = this.dbId(name, group);

      var value = await this.$db.options
        .get({
          id: id,
        })
        .catch(function (error) {
          console.log("error getting option" + error);
        });
      if (value === undefined) return;
      console.log(value);

      this.$refs[group + "-" + option].checked = value.option == option;

      console.log(
        "option loaded: " +
          id +
          ", option:" +
          option +
          ", selected:" +
          value.option
      );
    },
    saveOption(name, group, option) {
      var id = this.dbId(name, group);

      this.$db.options
        .put({
          id: id,
          option: option,
        })
        .catch(function (error) {
          console.log("error saving option" + error);
        });

      console.log("option saved: " + id + ", " + option);
    },
  },
};
</script>